module.exports = __webpack_public_path__ + "static/media/caution.2aa43fdf.gif";